import { PDF_SIGNED_URL_QUERY } from "src/constants/graphql/queries";
import { client as apolloClient } from "src/share/ApolloProvider";

const appendQueryParams = (url, extraQueryParams = {}) => {
  if (!url) return null;

  const parsedUrl = new URL(url, window.location.origin);

  Object.entries(extraQueryParams).forEach(([key, value]) => {
    if (value == null || value === "") return;
    parsedUrl.searchParams.set(key, String(value));
  });

  return parsedUrl.toString();
};

export const fetchPdfSignedUrl = async ({
  resourceType,
  resourceId,
  pathSuffix = null,
  extraQueryParams = {},
}) => {
  if (!resourceType || !resourceId) return null;

  const { data } = await apolloClient.query({
    query: PDF_SIGNED_URL_QUERY,
    variables: {
      resourceType,
      resourceId: String(resourceId),
      pathSuffix,
    },
    fetchPolicy: "no-cache",
  });

  return appendQueryParams(data?.pdfSignedUrl, extraQueryParams);
};

export const openSignedPdfUrl = async ({
  resourceType,
  resourceId,
  pathSuffix = null,
  extraQueryParams = {},
  target = "_blank",
}) => {
  // Open the window synchronously so mobile browsers don't block it as a
  // popup (they require window.open to be in the direct user-gesture stack).
  const newWindow = target === "_blank" ? window.open("about:blank", "_blank") : null;

  const signedUrl = await fetchPdfSignedUrl({
    resourceType,
    resourceId,
    pathSuffix,
    extraQueryParams,
  });

  if (!signedUrl) {
    if (newWindow) newWindow.close();
    return null;
  }

  if (newWindow) {
    newWindow.location.href = signedUrl;
  } else {
    window.location.assign(signedUrl);
  }

  return signedUrl;
};
